import { render, staticRenderFns } from "./ViewingView.vue?vue&type=template&id=023b630c&scoped=true"
import script from "./ViewingView.vue?vue&type=script&lang=js"
export * from "./ViewingView.vue?vue&type=script&lang=js"
import style0 from "./ViewingView.vue?vue&type=style&index=0&id=023b630c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b630c",
  null
  
)

export default component.exports